import type { SOArch, SOMaterial } from "~/common/constants";
import { fetchWithAuth } from "~/common/fetch";
import { formSubmitNotification } from "~/components/notifications/form_submit_pop";
import { API_POST_STATUS_POWER_CAP } from "~/config";
import type { TUserActionNotification } from "~/reducers/dashboard";
import type { AppDispatch, RootState } from "~/store";
import type { TPatient } from "~/types/patient";

export type TPowerCapShipment =
  | { ship_with_retainers: true }
  | { retainers: { treat_arches_id: SOArch; quantity: number } }
  | null;

import { addUserActionNotification } from "./user_notification";

export function orderPowerCap(
  patient_id: TPatient["patient_id"],
  material: SOMaterial,
  treatArchesOption: SOArch,
  comment: string,
  // The backend submits the child during creation, so deferred media must be included in this request.
  media: RootState["media"],
  media_s3: RootState["media_s3"],
  shipment: TPowerCapShipment = null,
) {
  const NOTIFICATION_MSG_OK: TUserActionNotification = {
    message: "notify.form.submitted.ok",
    level: "success",
    position: "tc",
    autoDismiss: 10,
    children: formSubmitNotification(),
  };

  const NOTIFICATION_MSG_ERROR: TUserActionNotification = {
    message: "notify.power_cap.error",
    level: "error",
    position: "tl",
    autoDismiss: 4,
  };

  return async (dispatch: AppDispatch) => {
    const response = await fetchWithAuth(API_POST_STATUS_POWER_CAP(patient_id), {
      method: "POST",
      body: JSON.stringify({
        material,
        treat_arches_id: treatArchesOption,
        comment,
        media_info: media,
        s3_media: media_s3,
        ...shipment,
      }),
    });
    if (!response.ok) {
      dispatch(addUserActionNotification(NOTIFICATION_MSG_ERROR));
      throw new Error("Error occurred trying to order a power cap");
    }
    const json = await response.json();
    dispatch({ type: "POST_STATUS_POWER_CAP", json });
    dispatch(addUserActionNotification(NOTIFICATION_MSG_OK));
    return json as TPatient;
  };
}
